/* eslint-disable react-hooks/exhaustive-deps */
import React, { useLayoutEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Layout,
  Card,
  Table,
  Button,
  Space,
  Input,
  Popconfirm,
  Tag,
} from "antd";
import { PlusOutlined } from "@ant-design/icons";

import LayoutHeader from "../inc/LayoutHeader";
import LayoutFooter from "../inc/LayoutFooter";

import { getAPI, postAPI, displayMessage } from "../../utils/common";
import { SUCCESS_MESSAGE, ERROR_MSG_TYPE } from "../../constants/messages";
import { KITCHEN_ITEM_LIST, KITCHEN_ITEM_DELETE } from "../../constants/api";

function KitchenItemTable() {
  const { Content } = Layout;
  const navigate = useNavigate();

  const [state, setState] = useState([]);
  const [filteredState, setFilteredState] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");

  useLayoutEffect(() => {
    getList();
  }, []);

  const getList = () => {
    setLoading(true);

    const successFn = (res) => {
      if (res.status === true) {
        const formatted = res.data.map((row, index) => ({
          key: index,
          ID: index + 1,
          Name: row.name,
          Code: row.item_code,
          Unit: row.unit,
          Stock: row.current_stock,
          Reorder: row.reorder_level,
          Rate: `₹ ${row.rate}`,
          ExpiryAlertDays: row.expiry_alert_days,
          Status: row.status ? (
            <Tag color="green">Active</Tag>
          ) : (
            <Tag color="red">Inactive</Tag>
          ),
          Action: (
            <Space>
              <Button
                size="small"
                onClick={() => navigate("/kitchen/item/edit/" + row.id)}
              >
                Edit
              </Button>

              <Popconfirm
                title="Delete Item"
                description="Are you sure to delete this item?"
                onConfirm={() => deleteData(row.id)}
                okText="Yes"
                cancelText="No"
              >
                <Button size="small" danger>
                  Delete
                </Button>
              </Popconfirm>
            </Space>
          ),
        }));

        setState(formatted);
        setFilteredState(formatted);
      } else {
        setState([]);
        setFilteredState([]);
      }
      setLoading(false);
    };

    const errorFn = () => {
      setLoading(false);
      setState([]);
      setFilteredState([]);
    };

    getAPI(KITCHEN_ITEM_LIST, successFn, errorFn, {});
  };

  const deleteData = (id) => {
    setLoading(true);

    const successFn = (res) => {
      if (res.status === true) {
        displayMessage(SUCCESS_MESSAGE, res.message);
        getList();
      } else {
        setLoading(false);
        displayMessage(ERROR_MSG_TYPE, res.message);
      }
    };

    const errorFn = () => {
      setLoading(false);
      displayMessage(ERROR_MSG_TYPE, "Unable to delete item");
    };

    postAPI(KITCHEN_ITEM_DELETE, { id }, successFn, errorFn);
  };

  const handleSearch = (value) => {
    setSearchText(value);

    const filtered = state.filter((row) =>
      row.Name.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredState(filtered);
  };

  const columns = [
    { title: "S.No", dataIndex: "ID", width: 60 },
    { title: "Item Code", dataIndex: "Code", width: 120 },
    { title: "Item Name", dataIndex: "Name", width: 200 },
    { title: "Unit", dataIndex: "Unit", width: 80 },
    { title: "Current Stock", dataIndex: "Stock", width: 120 },
    { title: "Low Stock Alert", dataIndex: "Reorder", width: 120 },
    { title: "Rate", dataIndex: "Rate", width: 100 },
    { title: "Ex. alert day", dataIndex: "ExpiryAlertDays", width: 100 },
    { title: "Status", dataIndex: "Status", width: 100 },
    { title: "Action", dataIndex: "Action", width: 160 },
  ];

  return (
    <Layout>
      <LayoutHeader />
      <Content>
        <Card
          title="Kitchen Items"
          bordered
          extra={
            <Space>
              <Input
                placeholder="Search by item name"
                value={searchText}
                onChange={(e) => handleSearch(e.target.value)}
                style={{ width: 250 }}
              />
              <Button
                type="primary"
                onClick={() => navigate("/kitchen/item/add")}
              >
                Add Item <PlusOutlined />
              </Button>
            </Space>
          }
        >
          <Table
            loading={loading}
            columns={columns}
            dataSource={filteredState}
            pagination={{ pageSize: 10 }}
            scroll={{ x: 900 }}
          />
        </Card>
      </Content>
      <LayoutFooter />
    </Layout>
  );
}

export default KitchenItemTable;
